import React, { useEffect, useState } from 'react';
import { Text, View, Image } from '@react-pdf/renderer';

import { styleContent, fontStyles } from './styleBonafidePdf';


const BonafideNotice = (props) => {
    const [notes, setNotes] = useState("");

    useEffect(() => {
        // console.log("BonafideNotice component called, props.studentNotes", props.studentNotes);
        setNotes(props.studentNotes);
    }, [props.studentNotes]);

    return (
        <View style={styleContent.studentNote}>
            <Text style={fontStyles.fontInterItalic}>
                {notes}
            </Text>
        </View>
    )
}

export default BonafideNotice;